import styled from 'styled-components';

const Section = styled.section`
  padding: 4em;
  background: ${props => props.primary ? '#80D8FF' : '#ECECEC'};
`;

export default Section;



// WEBPACK FOOTER //
// ./src/components/Section.js